export default {
  startLoading: 'Beladung starten',
  finishLoading: 'Beladung beenden',
  loadEditDisabled: 'Nur geplante Chargen können bearbeitet werden.',
  startLoad: 'Charge starten',
  confirmStartLoad: 'Charge "{load}" starten?',
  confirmStartLoading: 'Beladung von "{load}" starten?',
  confirmFinishLoading: 'Beladung von "{load}" beenden?',
};
